import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useEventLogging } from '../../../../../../../../models/Logging';
import { useSingleEmailComposer } from '../../../../../../../../models/hooks/appStateHooks';
import { Button } from '../../../../../../../components-v2/Button';
import { EmailIcon } from '../../../../../../../components/svgs/icons/EmailIcon';
import { styleSheet } from './styles';

interface IProps {
	item: Api.ActionItemEventViewModel;
	onEmailModalDismiss?: () => void;
	onEmailModalFinished?: (didSend: boolean) => void;
}

export const ActionItemAction = ({ item, onEmailModalDismiss, onEmailModalFinished }: IProps) => {
	const singleEmailComposer = useSingleEmailComposer();
	const { logInput } = useEventLogging('ActionItemTimeline');

	const actionItem = item.viewmodel;

	// Determine if send email button should be shown (same logic as old ActionItemFeedCard)
	const shouldShowSendEmailButton = actionItem.referencedContactsForSendMessage?.length > 0;

	const handleSendEmailClick = () => {
		// Log the event (same as old ActionItemFeedCard)
		logInput('SendMessage', 'Click', {
			actionItem: {
				id: actionItem.id,
			},
			recipients: (actionItem.referencedContactsForSendMessage || []).map(contact => contact.id),
		});

		// Open the email composer with callbacks
		singleEmailComposer.showForActionItem(actionItem, {
			onDismiss: () => {
				// Call the callback if provided (for timeline refresh, etc.)
				if (onEmailModalDismiss) {
					onEmailModalDismiss();
				}
			},
			onFinish: (didSend: boolean) => {
				// Call the callback if provided (for timeline refresh, etc.)
				if (onEmailModalFinished) {
					onEmailModalFinished(didSend);
				}
			},
		});
	};

	// Don't render if no contacts to send to
	if (!shouldShowSendEmailButton) {
		return null;
	}

	return (
		<Button styles={[styleSheet.actionItemAction]} size='sm' onClick={handleSendEmailClick}>
			<EmailIcon className={css(styleSheet.actionItemActionIcon)} height={16} width={16} />
			<span className={css(styleSheet.actionItemActionText)}>Send Email</span>
		</Button>
	);
};
